"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetPassword = exports.requestPasswordReset = exports.refreshActivity = exports.reconfirmAuth = exports.navigateToForgotPassword = exports.logout = exports.loginWithJwt = exports.login = exports.initializeConfigs = exports.expireBlastSession = exports.acceptTermsOfService = exports.updateTermsOfServiceAcceptance = exports.updateAuthCheckComplete = exports.setAsperaPluginTransferLimit = exports.resetPasswordSuccess = exports.resetPasswordRequest = exports.resetPasswordReject = exports.requestPasswordResetSuccess = exports.requestPasswordResetRequest = exports.requestPasswordResetReject = exports.requestPasswordResetLoad = exports.refreshActivityAction = exports.logoutSuccess = exports.logoutRequest = exports.loginSuccess = exports.loginRequest = exports.loginReject = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* Package Imports */
var axios_1 = __importDefault(require("axios"));
var connected_react_router_1 = require("connected-react-router");
var typesafe_actions_1 = require("typesafe-actions");
var AuthApi = __importStar(require("@app/services/api/auth"));
var UsersApi = __importStar(require("@app/services/api/users"));
var constants_1 = require("@app/shared/constants");
var matomo_1 = require("@app/shared/matomo");
var utils_1 = require("@app/shared/utils");
var utils_2 = require("@server/shared/utils");
var createAction = typesafe_actions_1.deprecated.createAction;
/* Action Creators - begin */
exports.loginReject = createAction('@@auth/LOGIN_REJECT', function (resolve) { return function (message, initiateLogout) { return resolve({ message: message, initiateLogout: initiateLogout || false }); }; });
exports.loginRequest = createAction('@@auth/LOGIN_REQUEST', function (resolve) { return function (username) { return resolve(username); }; });
exports.loginSuccess = createAction('@@auth/LOGIN_SUCCESS', function (resolve) { return function (auth) { return resolve(auth); }; });
exports.logoutRequest = createAction('@@auth/LOGOUT_REQUEST');
exports.logoutSuccess = createAction('@@auth/LOGOUT_SUCCESS');
exports.refreshActivityAction = createAction('@auth/REFRESH_ACTIVITY_ACTION', function (resolve) { return function (activityTimestamp) { return resolve(activityTimestamp); }; });
exports.requestPasswordResetLoad = createAction('@auth/REQUEST_PASSWORD_RESET_LOAD');
exports.requestPasswordResetReject = createAction('@auth/REQUEST_PASSWORD_RESET_REJECT', function (resolve) { return function (error) { return resolve(error); }; });
exports.requestPasswordResetRequest = createAction('@auth/REQUEST_PASSWORD_RESET_REQUEST');
exports.requestPasswordResetSuccess = createAction('@auth/REQUEST_PASSWORD_RESET_SUCCESS');
exports.resetPasswordReject = createAction('@@auth/RESET_REJECT', function (resolve) { return function (error) { return resolve(error); }; });
exports.resetPasswordRequest = createAction('@@auth/RESET_REQUEST', function (resolve) { return function (token) { return resolve(token); }; });
exports.resetPasswordSuccess = createAction('@auth/RESET_SUCCESS');
exports.setAsperaPluginTransferLimit = createAction('@auth/SET_ASPERA_PLUGIN_TRANSFER_LIMIT', function (resolve) { return function (limit) { return resolve(limit); }; });
exports.updateAuthCheckComplete = createAction('@@auth/UPDATE_AUTH_CHECK_COMPLETE');
exports.updateTermsOfServiceAcceptance = createAction('@auth/UPDATE_TERMS_OF_SERVICE_ACCEPTANCE', function (resolve) { return function (acceptance) { return resolve(acceptance); }; });
/* Action Creators - end */
/* Authentication's Action Functions - begin */
// Accept the "Terms of Service"
var acceptTermsOfService = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, UsersApi.acceptTermsOfService()];
                case 1:
                    _a.sent();
                    dispatch(exports.updateTermsOfServiceAcceptance(true));
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.acceptTermsOfService = acceptTermsOfService;
// Reset Matomo configuration
var deinitializeMatomo = function () {
    var matomo = new matomo_1.MatomoTracker();
    matomo.deinitialize();
};
// Expire the user's session and log them out
var expireBlastSession = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.resolve(dispatch(exports.logoutRequest()))];
                case 1:
                    _a.sent();
                    deinitializeMatomo();
                    utils_1.clearHasbroSessionStorageKeys();
                    delete axios_1.default.defaults.headers.common.authorization;
                    dispatch(exports.refreshActivity(false));
                    return [4 /*yield*/, Promise.resolve(dispatch(exports.logoutSuccess()))];
                case 2:
                    _a.sent();
                    dispatch(exports.loginReject('You have been logged out due to inactivity', true));
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.expireBlastSession = expireBlastSession;
// Setup configurations in Blast ui, that are needed from the server side
var initializeConfigs = function (auth) { return __awaiter(void 0, void 0, void 0, function () {
    var serverConfigs, matomo;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, AuthApi.getServerConfigs()];
            case 1:
                serverConfigs = _a.sent();
                matomo = new matomo_1.MatomoTracker();
                return [4 /*yield*/, Promise.resolve(matomo.initialize(serverConfigs.matomo.siteId, serverConfigs.matomo.hostUrl))];
            case 2:
                _a.sent();
                return [4 /*yield*/, Promise.resolve(matomo.setUser(auth.user.userEmail))];
            case 3:
                _a.sent();
                matomo.trackPageView();
                if (typeof localStorage === 'object') {
                    localStorage.setItem(constants_1.BLAST_ENV, serverConfigs.clientEnv);
                }
                return [2 /*return*/, [serverConfigs.asperaPluginTransferLimit, serverConfigs.blastPackageExpirationDays]];
        }
    });
}); };
exports.initializeConfigs = initializeConfigs;
// Login to Blast, using user credentials
var login = function (username, password, state) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var jwt, decodedJwt, tosResponse, _a, _b, _c, _d, error_1;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 5, , 6]);
                    dispatch(exports.loginRequest(username));
                    return [4 /*yield*/, AuthApi.login(username, password, state)];
                case 1:
                    jwt = _e.sent();
                    decodedJwt = utils_1.decodeJwt(jwt);
                    sessionStorage.setItem(constants_1.JWT_STORAGE_KEY, jwt);
                    localStorage.setItem(constants_1.BLAST_LOGIN, new Date(decodedJwt.iat * 1000).toJSON());
                    dispatch(exports.refreshActivity(true));
                    axios_1.default.defaults.headers.common.authorization = "Bearer " + jwt;
                    return [4 /*yield*/, UsersApi.getTermsOfServiceAcceptance()];
                case 2:
                    tosResponse = _e.sent();
                    dispatch(exports.updateTermsOfServiceAcceptance(tosResponse.currentTosAcceptanceValid));
                    _b = (_a = Promise).resolve;
                    _c = dispatch;
                    _d = exports.setAsperaPluginTransferLimit;
                    return [4 /*yield*/, exports.initializeConfigs(decodedJwt.auth)];
                case 3: return [4 /*yield*/, _b.apply(_a, [_c.apply(void 0, [_d.apply(void 0, [_e.sent()])])])];
                case 4:
                    _e.sent();
                    dispatch(exports.loginSuccess(decodedJwt.auth));
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _e.sent();
                    if (error_1.response && error_1.response.data && error_1.response.data.error && error_1.response.data.error.includes('expired_password')) {
                        dispatch(exports.requestPasswordReset(username));
                        dispatch(connected_react_router_1.push('/password-expired'));
                    }
                    dispatch(exports.loginReject('There was an error while logging in. Please check your username/password or click "Forgot password" below'));
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
};
exports.login = login;
// Login to Blast, using JWT token
var loginWithJwt = function (jwt) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var verifiedJwt, decodedJwt, tosResponse, _a, _b, _c, _d, error_2;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 7, , 9]);
                    jwt = jwt || sessionStorage.getItem(constants_1.JWT_STORAGE_KEY);
                    if (!jwt) return [3 /*break*/, 5];
                    dispatch(exports.loginRequest(''));
                    return [4 /*yield*/, AuthApi.verifyAuth(jwt)];
                case 1:
                    verifiedJwt = _e.sent();
                    if (!verifiedJwt) {
                        throw new Error('There was an error checking your login status. Please try logging in again.');
                    }
                    decodedJwt = utils_1.decodeJwt(jwt);
                    sessionStorage.setItem(constants_1.JWT_STORAGE_KEY, jwt);
                    localStorage.setItem(constants_1.BLAST_LOGIN, new Date(decodedJwt.iat * 1000).toJSON());
                    dispatch(exports.refreshActivity(true));
                    axios_1.default.defaults.headers.common.authorization = "Bearer " + jwt;
                    return [4 /*yield*/, UsersApi.getTermsOfServiceAcceptance()];
                case 2:
                    tosResponse = _e.sent();
                    dispatch(exports.updateTermsOfServiceAcceptance(tosResponse.currentTosAcceptanceValid));
                    _b = (_a = Promise).resolve;
                    _c = dispatch;
                    _d = exports.setAsperaPluginTransferLimit;
                    return [4 /*yield*/, exports.initializeConfigs(decodedJwt.auth)];
                case 3: return [4 /*yield*/, _b.apply(_a, [_c.apply(void 0, [_d.apply(void 0, [_e.sent()])])])];
                case 4:
                    _e.sent();
                    dispatch(exports.loginSuccess(decodedJwt.auth));
                    return [3 /*break*/, 6];
                case 5:
                    dispatch(exports.updateAuthCheckComplete());
                    _e.label = 6;
                case 6: return [3 /*break*/, 9];
                case 7:
                    error_2 = _e.sent();
                    return [4 /*yield*/, dispatch(exports.expireBlastSession())];
                case 8:
                    _e.sent();
                    dispatch(exports.updateAuthCheckComplete());
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); };
};
exports.loginWithJwt = loginWithJwt;
// Logout of Blast
var logout = function (redirectOnLogout) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(exports.logoutRequest());
            utils_1.clearHasbroSessionStorageKeys();
            dispatch(exports.refreshActivity(false));
            delete axios_1.default.defaults.headers.common.authorization;
            dispatch(exports.logoutSuccess());
            new matomo_1.MatomoTracker().trackEvent('User', 'Log Out');
            deinitializeMatomo();
            if (redirectOnLogout) {
                localStorage.setItem(constants_1.LOGOUT_TRIGGER_KEY, (new Date().getTime().toString()));
                localStorage.removeItem(constants_1.LOGOUT_TRIGGER_KEY);
                dispatch(connected_react_router_1.push('/login'));
            }
            return [2 /*return*/];
        });
    }); };
};
exports.logout = logout;
// Redirect to "Forgot Password" page
var navigateToForgotPassword = function (email) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(exports.requestPasswordResetLoad());
            dispatch(connected_react_router_1.push({ pathname: '/forgot-password', state: { email: email } }));
            return [2 /*return*/];
        });
    }); };
};
exports.navigateToForgotPassword = navigateToForgotPassword;
// Confirm the user is still authorized to use Blast
var reconfirmAuth = function (activityTimestamp) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var jwt, decodedJwt, refreshedJwt, error_3, pathName;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    if (!(sessionStorage && ('function' === typeof sessionStorage.getItem))) return [3 /*break*/, 2];
                    jwt = sessionStorage.getItem(constants_1.JWT_STORAGE_KEY);
                    if (!jwt) return [3 /*break*/, 2];
                    decodedJwt = utils_1.decodeJwt(jwt);
                    if (Date.now() > (activityTimestamp.getTime() + (decodedJwt.validityInSeconds * 1000))) {
                        throw new Error('Your session expired due to inactivity. Please log back in again.');
                    }
                    return [4 /*yield*/, AuthApi.refreshAuth(jwt)];
                case 1:
                    refreshedJwt = _a.sent();
                    if (!refreshedJwt) {
                        throw new Error('There was an error checking your login status. Please try logging in again.');
                    }
                    sessionStorage.setItem(constants_1.JWT_STORAGE_KEY, refreshedJwt);
                    axios_1.default.defaults.headers.common.authorization = "Bearer " + refreshedJwt;
                    dispatch(exports.refreshActivity(true));
                    _a.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    error_3 = _a.sent();
                    pathName = window.location.pathname;
                    deinitializeMatomo();
                    utils_1.clearHasbroSessionStorageKeys();
                    delete axios_1.default.defaults.headers.common.authorization;
                    dispatch(exports.refreshActivity(false));
                    dispatch(exports.loginReject(error_3.message));
                    dispatch(connected_react_router_1.push("/login?redirectTo=" + pathName));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.reconfirmAuth = reconfirmAuth;
// Update stored activity timestamp, or clear the activity storage
var refreshActivity = function (isActive) {
    return function (dispatch) {
        if (isActive) {
            var now = new Date();
            if (typeof localStorage === 'object') {
                localStorage.setItem(constants_1.BLAST_ACTIVITY, now.toJSON());
            }
            dispatch(exports.refreshActivityAction(now));
        }
        else {
            localStorage.removeItem(constants_1.BLAST_ACTIVITY);
            localStorage.removeItem(constants_1.BLAST_ENV);
            localStorage.removeItem(constants_1.BLAST_LOGIN);
            dispatch(exports.refreshActivityAction(undefined));
        }
    };
};
exports.refreshActivity = refreshActivity;
// Request a token to reset the password for the given email
var requestPasswordReset = function (email) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    dispatch(exports.requestPasswordResetRequest());
                    return [4 /*yield*/, AuthApi.requestResetPasswordEmail(email)];
                case 1:
                    _b.sent();
                    dispatch(exports.requestPasswordResetSuccess());
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    dispatch(exports.requestPasswordResetReject('An error occurred while sending the reset email'));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.requestPasswordReset = requestPasswordReset;
// Reset the password for a user, based on the provided token
var resetPassword = function (token, password, confirmPassword) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var error_4, errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(exports.resetPasswordRequest(token));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, AuthApi.resetPassword(token, utils_2.Base64Util.toBase64(password), utils_2.Base64Util.toBase64(confirmPassword))];
                case 2:
                    _a.sent(); // encode password
                    dispatch(exports.resetPasswordSuccess());
                    dispatch(connected_react_router_1.push('/login', { fromPasswordReset: true }));
                    return [3 /*break*/, 4];
                case 3:
                    error_4 = _a.sent();
                    errorMessage = (error_4.response && error_4.response.data) ?
                        error_4.response.data :
                        'An error occurred while resetting your password';
                    dispatch(exports.resetPasswordReject(errorMessage));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.resetPassword = resetPassword;
/* Authentication's Action Functions - end */ 
